module.exports = __webpack_public_path__ + "img/universidades.0c74aa2e.png";